module.exports = __webpack_public_path__ + "img/tracking.36a12842.png";